import type { IconData } from '@stacksjs/iconify-core'

export const font: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M221.631 109L109.92 392h58.055l24.079-61h127.892l24.079 61h58.055L290.369 109Zm-8.261 168L256 169l42.63 108Z\"/><path fill=\"currentColor\" d=\"M16 496h480V16H16ZM48 48h416v416H48Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default font
